export const BlockedStopIcon = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="-2.5 -4 35 35"
      id="svg5"
      version="1.1"
    >
      <defs id="defs2" />

      <g id="layer1" transform="translate(-60,-148)">
        <path
          d="m 76,150.00586 c -1.213462,0 -2.266029,0.73968 -2.736328,1.78711 -0.385498,-0.18184 -0.812675,-0.28711 -1.263672,-0.28711 -1.644697,0 -3,1.3553 -3,3 v 6.13867 c -0.27127,-0.0905 -0.561082,-0.13867 -0.863281,-0.13867 h -0.273438 c -1.608292,0 -2.863281,1.39204 -2.863281,3 v 3.5 c 10e-7,6.06326 4.936731,11 11,11 6.06327,0 11.000001,-4.93674 11,-11 v -10 c 0,-1.6447 -1.355303,-3 -3,-3 -0.357295,0 -0.698527,0.0685 -1.017578,0.18555 -0.159574,-1.49938 -1.44393,-2.68555 -2.982422,-2.68555 -0.450997,0 -0.878174,0.10527 -1.263672,0.28711 C 78.266027,150.74554 77.213461,150.00586 76,150.00586 Z m 0,2 c 0.571295,0 1,0.4287 1,1 v 1.5 c 0,3 0,6 0,9 0,0.55228 0.447716,1 1,1 0.552284,0 1,-0.44772 1,-1 0,-3 0,-6 0,-9 0,-0.5713 0.428705,-1 1,-1 0.571295,0 1,0.4287 1,1 v 2.5 5.4375 1.0625 c 0,0.55228 0.447716,1 1,1 0.552284,0 1,-0.44772 1,-1 v -1.0625 -5.4375 c 0,-0.5713 0.428705,-1 1,-1 0.571295,0 1,0.4287 1,1 v 10 c 0,4.98238 -4.017607,9 -9,9 -4.982392,0 -9,-4.01762 -9,-9 v -3.5 c 0,-0.60804 0.407262,-1 0.863281,-1 h 0.273438 c 0.456004,0 0.863281,0.39197 0.863281,1 v 3.5 c 0,0.55228 0.447717,1 1,1 0.552283,0 1,-0.44772 1,-1 v -3.5 -9 c 0,-0.5713 0.428705,-1 1,-1 0.571295,0 1,0.4287 1,1 v 9 c 0,0.55228 0.447716,1 1,1 0.552284,0 1,-0.44772 1,-1 v -9 -1.5 c 0,-0.5713 0.428705,-1 1,-1 z"
          id="rect2272"
        />
      </g>
    </svg>
  );
};
